/* ============================================================
   NZSupps — Find Your Pre-Workout quiz engine (fork of nzs-quiz.js).
   Vanilla JS, no dependencies. Reads two JSON blobs in the page:
     #nzpwq-config   — questions + result map + copy (editable in the section .liquid)
     #nzpwq-products — live product data keyed by handle (Liquid-rendered from the pool collection)
   Renders a step quiz, scores answers to a curated stack, adds to cart.
   Cards support flavour + size selectors (custom.fys_flavours), per-serve/servings,
   a subscribe delivery-frequency slider, and a tested chip. Progress persists in a 7-day cookie.
   ============================================================ */
(function () {
  'use strict';

  var cfgEl = document.getElementById('nzpwq-config');
  var prodEl = document.getElementById('nzpwq-products');
  var app = document.getElementById('nzpwq-app');
  if (!cfgEl || !prodEl || !app) return;

  var CONFIG, PRODUCTS;
  try {
    CONFIG = JSON.parse(cfgEl.textContent);
    PRODUCTS = JSON.parse(prodEl.textContent);
  } catch (e) { console.error('[NZSupps quiz] config parse failed', e); return; }

  var stage = app.querySelector('[data-nzsq-stage]');
  var bar = app.querySelector('[data-nzsq-progress]');
  var backBtn = app.querySelector('[data-nzsq-back]');
  var closeBtn = app.querySelector('[data-nzsq-close]');
  var questions = CONFIG.questions || [];
  var TPL = {
    question: document.getElementById('nzpwq-question-tpl'),
    option: document.getElementById('nzpwq-option-tpl'),
    card: document.getElementById('nzpwq-result-card-tpl')
  };
  var state = { step: 0, answers: {}, lastFocus: null };
  var forcedSeg = null;            /* NZS-QUIZFIX: universal off-ramp / forced downsell view */
  var CARDS = [];            /* per-result-card state (handle, art, flavours, sel, entry) */
  var currentMode = 'onetime';
  var selectedWeek = 6;      /* subscribe delivery cadence (weeks) */
  var freqEl = null;         /* the frequency slider wrapper (toggled with mode) */
  var COOKIE = 'nzpwq_progress';

  /* ---- NZS-QUIZFIX motion (page-animate two-speed; ported from should-i-take-pre-workout) ---- */
  var SLOW = 600, QUICK = 150;
  function prefersReduced() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function canAnimate() { return !prefersReduced() && !document.hidden; }
  function withExit(next) {
    var cur = stage.querySelector('.nzsq-q');
    if (!cur || !canAnimate()) { next(); return; }
    cur.classList.add('nzpwq-q-exit');
    var done = false, go = function () { if (done) return; done = true; next(); };
    cur.addEventListener('animationend', go, { once: true });
    setTimeout(go, QUICK + 90);
  }
  function playEnter(node, cls, dur) {
    if (!node) return;
    if (!canAnimate()) { node.classList.remove(cls); node.style.willChange = ''; return; }
    node.classList.add(cls);
    var done = false, clr = function () { if (done) return; done = true; node.classList.remove(cls); node.style.willChange = ''; };
    node.addEventListener('animationend', clr, { once: true });
    setTimeout(clr, dur + 140);
  }
  function fireReveal(node, delay) {
    if (!node) return;
    if (!canAnimate()) { node.classList.remove('nzpwq-reveal', 'nzpwq-in'); node.style.willChange = ''; return; }
    var d = delay || 0;
    node.style.animationDelay = d + 'ms';
    node.classList.add('nzpwq-in');
    var done = false, clr = function () { if (done) return; done = true; node.classList.remove('nzpwq-reveal', 'nzpwq-in'); node.style.animationDelay = ''; node.style.willChange = ''; };
    node.addEventListener('animationend', clr, { once: true });
    setTimeout(clr, SLOW + d + 140);
  }
  function echoLine() {
    var a = state.answers, parts = [];
    var caff = { sensitive: 'Easy on the caffeine', moderate: 'A couple of coffees deep', high: 'Caffeine is no issue', max: 'Built different on caffeine', avoid: 'No caffeine' }[a.caffeine];
    var time = { morning: 'morning sessions', afternoon: 'afternoon sessions', evening: 'training close to bed' }[a.time];
    var ting = { love: 'tingles welcome', hate: 'no tingles', never: 'tingles untested' }[a.tingles];
    if (caff) parts.push(caff);
    if (time) parts.push(time);
    if (ting) parts.push(ting);
    return parts.length ? parts.join(', ') + '.' : '';
  }

  /* ---- cookies (7-day progress) ---- */
  function setCookie(name, val, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }
  function delCookie(name) { document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'; }
  function saveProgress() { try { setCookie(COOKIE, JSON.stringify({ step: state.step, answers: state.answers }), 7); } catch (e) {} }
  function loadProgress() { try { var raw = getCookie(COOKIE); if (!raw) return null; var o = JSON.parse(raw); if (o && o.answers) return o; } catch (e) {} return null; }

  /* ---- open / close ---- */
  function open(seedGoal) {
    state.lastFocus = document.activeElement;
    state.step = 0; state.answers = {}; forcedSeg = null;
    if (seedGoal && (CONFIG.resultMap || {})[seedGoal]) { state.answers.goal = seedGoal; state.step = 1; }
    else { var p = loadProgress(); if (p) { state.answers = p.answers || {}; state.step = Math.min(p.step || 0, questions.length); } }
    app.hidden = false;
    document.documentElement.classList.add('nzsq-lock');
    saveProgress();
    render();
  }
  function close() {
    app.hidden = true;
    document.documentElement.classList.remove('nzsq-lock');
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
  }

  /* ---- nav ---- */
  function advance() { withExit(function () { state.step++; render(); }); }
  function back() { forcedSeg = null; if (state.step > 0) withExit(function () { state.step--; render(); }); }
  function setProgress(done, total) { if (bar) bar.style.width = Math.min(Math.round(done / total * 100), 100) + '%'; }

  function render() {
    backBtn.hidden = state.step === 0;
    if (state.step < questions.length) { setProgress(state.step, questions.length + 1); renderQuestion(questions[state.step]); }
    else { setProgress(questions.length + 1, questions.length + 1); renderResults(); }
    saveProgress();
    stage.scrollTop = 0;
    var f = stage.querySelector('button, input, a, select'); if (f) f.focus();
  }

  /* ---- question ---- */
  function renderQuestion(q) {
    stage.textContent = '';
    var node = TPL.question.content.cloneNode(true);
    node.querySelector('[data-count]').textContent = 'Question ' + (state.step + 1) + ' of ' + questions.length;
    node.querySelector('[data-title]').textContent = q.title;
    var hintEl = node.querySelector('[data-hint]'); if (hintEl) hintEl.textContent = q.hint || '';
    var wrap = node.querySelector('[data-options]');
    var multi = q.type === 'multi';
    var chosen = multi ? (state.answers[q.id] || []) : state.answers[q.id];

    q.options.forEach(function (opt) {
      var o = TPL.option.content.cloneNode(true);
      var btn = o.querySelector('.nzsq-option');
      o.querySelector('[data-label]').textContent = opt.label;
      var dEl = o.querySelector('[data-desc]'); if (dEl) dEl.textContent = opt.desc || '';
      var sel = multi ? chosen.indexOf(opt.id) !== -1 : chosen === opt.id;
      if (sel) btn.setAttribute('aria-pressed', 'true');
      btn.addEventListener('click', function () {
        if (multi) { toggleMulti(q, opt.id, wrap); }
        else {
          state.answers[q.id] = opt.id;
          wrap.querySelectorAll('.nzsq-option').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          setTimeout(advance, 200);
        }
      });
      wrap.appendChild(o);
    });

    if (multi) {
      var foot = node.querySelector('[data-foot]');
      var cont = document.createElement('button');
      cont.type = 'button'; cont.className = 'nzsq-btn nzsq-btn--primary';
      cont.textContent = q.cta || 'Continue';
      cont.addEventListener('click', function () {
        if (!state.answers[q.id]) state.answers[q.id] = [];
        advance();
      });
      foot.appendChild(cont);
    }
    stage.appendChild(node);
    playEnter(stage.querySelector('.nzsq-q'), 'nzpwq-q-enter', SLOW);
  }
  function toggleMulti(q, id, wrap) {
    var EXCL = ['none', 'any'];
    var arr = state.answers[q.id] || [];
    if (EXCL.indexOf(id) !== -1) arr = [id];
    else { arr = arr.filter(function (x) { return EXCL.indexOf(x) === -1; }); var i = arr.indexOf(id); if (i !== -1) arr.splice(i, 1); else arr.push(id); }
    state.answers[q.id] = arr;
    var opts = wrap.querySelectorAll('.nzsq-option');
    q.options.forEach(function (opt, idx) { if (opts[idx]) opts[idx].setAttribute('aria-pressed', arr.indexOf(opt.id) !== -1 ? 'true' : 'false'); });
    saveProgress();
  }

  /* ---- scoring ---- */
  function answerHas(qid, val) { var a = state.answers[qid]; return Array.isArray(a) ? a.indexOf(val) !== -1 : a === val; }
  function avail(h) { return !!(h && PRODUCTS[h] && PRODUCTS[h].available !== false); }
  /* slot = string or ordered array; first in-stock entry wins (OOS upsells auto-show on restock) */
  function slotPick(slot) {
    if (!slot) return null;
    var arr = Array.isArray(slot) ? slot : [slot];
    for (var i = 0; i < arr.length; i++) if (avail(arr[i])) return arr[i];
    return null;
  }
  function resolveSwap(base, swaps) {
    if (!swaps) return slotPick(base);
    for (var i = 0; i < swaps.length; i++) {
      var s = swaps[i], ans = state.answers[s.q], hit = false;
      if (Array.isArray(ans)) { for (var j = 0; j < s.in.length; j++) { if (ans.indexOf(s.in[j]) !== -1) { hit = true; break; } } }
      else hit = s.in.indexOf(ans) !== -1;
      if (hit && avail(s.use)) return s.use;
    }
    return slotPick(base);
  }
  /* derive the routed segment + caffeine ceiling from the raw answers; writes _-prefixed
     pseudo-answers so the swap machinery keys on them unchanged */
  function deriveSegment() {
    var a = state.answers;
    var capMg = { avoid: 0, sensitive: 100, moderate: 200, high: 300, max: 400 }[a.caffeine];
    if (capMg == null) capMg = 200;
    if (a.time === 'evening') capMg = 0;                       // no in-stock stim powder <=100mg; sleep wins
    if (a.sideeffects === 'jitters' && capMg > 100) capMg = capMg === 400 ? 300 : capMg === 300 ? 200 : 100;
    if (a.experience === 'first' && capMg > 150) capMg = 150;
    a._cap = 'c' + capMg;                                      // c0 | c100 | c150 | c200 | c300 | c400
    a._evening = a.time === 'evening' ? 'yes' : 'no';
    a._crashhigh = (a.sideeffects === 'crash' && capMg >= 300) ? 'yes' : 'no';
    a._hatelow = (a.tingles === 'hate' && capMg > 0 && capMg <= 150) ? 'yes' : 'no';
    /* NZS-QUIZFIX 2026-07-12: was a 4-way AND (goal simple + hate tingles + avoid/evening) that
       only 3.1% of combos could reach and 'sensitive' never counted. Now: wants-simple + any
       caffeine/timing constraint = the tub is the wrong buy. Clean 'simple' pickers still get C4. */
    var downsell = a.goal === 'simple' && (a.caffeine === 'avoid' || a.caffeine === 'sensitive' || a.time === 'evening');
    a._segment = downsell ? (a.drinks === 'yes' ? 'downsell-rtd' : 'downsell-protein') : a.goal;
    return a._segment;
  }
  function score() {
    var seg = forcedSeg || deriveSegment(), map = (CONFIG.resultMap || {})[seg];
    if (!map) return null;
    var heroH = resolveSwap(map.hero, map.heroSwaps);
    var supH = map.support ? resolveSwap(map.support, map.supportSwaps) : null;
    var addH = map.addon ? resolveSwap(map.addon, map.addonSwaps) : null;
    if (supH === heroH) supH = null;
    if (addH === heroH || addH === supH) addH = null;
    return {
      goal: seg,
      hero: avail(heroH) ? heroH : null,
      support: supH && avail(supH) ? supH : null,
      addon: addH && avail(addH) ? addH : null
    };
  }

  /* ---- flavour / size helpers (mirror Build Your Stack) ---- */
  function parseServ(v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; }
  function pretty(s) { return String(s || '').split('-').map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join(' '); }
  function flavLabel(fl) { if (!fl) return 'Standard'; return pretty(fl); }
  function sizeLabel(sz) { return sz ? pretty(sz) : 'One size'; }
  function familyName(title) { return String(title || '').split(' - ')[0]; }
  function isAccessory(p) { return /shaker|accessor|bottle/i.test((p && p.type) || ''); }
  function fmtCents(c) { c = Number(c); if (isNaN(c)) return ''; return '$' + (c / 100).toFixed(2); }
  function serveLine(priceCents, servings) {
    var s = parseInt(servings, 10); if (!s || s <= 0) return '';
    var per = Math.round(Number(priceCents) / s); if (!per || isNaN(per)) return '';
    return fmtCents(per) + '/serve <i>&middot;</i> ' + s + ' serves';
  }
  function entryByVid(flavours, vid) { for (var i = 0; i < flavours.length; i++) if (String(flavours[i].vid) === String(vid)) return flavours[i]; return null; }
  function firstAvail(arr) { for (var i = 0; i < arr.length; i++) if (arr[i].available !== false) return arr[i]; return null; }
  function defaultEntry(flavours, baseVid) { return entryByVid(flavours, baseVid) || firstAvail(flavours) || flavours[0]; }
  function uniq(arr) { var o = [], seen = {}; arr.forEach(function (x) { var k = String(x); if (!seen[k]) { seen[k] = 1; o.push(x); } }); return o; }
  function distinctSizes(flavours) { return uniq(flavours.map(function (f) { return f.size || ''; })); }
  function flavoursForSize(flavours, size) { return uniq(flavours.filter(function (f) { return (f.size || '') === (size || ''); }).map(function (f) { return f.flavour || ''; })); }
  function sizesForFlavour(flavours, flavour) { return uniq(flavours.filter(function (f) { return (f.flavour || '') === (flavour || ''); }).map(function (f) { return f.size || ''; })); }
  function pickEntry(flavours, flavour, size) {
    var i;
    for (i = 0; i < flavours.length; i++) { if ((flavours[i].flavour || '') === (flavour || '') && (flavours[i].size || '') === (size || '')) return flavours[i]; }
    for (i = 0; i < flavours.length; i++) { if ((flavours[i].flavour || '') === (flavour || '')) return flavours[i]; }
    for (i = 0; i < flavours.length; i++) { if ((flavours[i].size || '') === (size || '')) return flavours[i]; }
    return flavours[0];
  }
  function nearestPlan(plans, week) {
    var keys = Object.keys(plans || {}).map(Number).filter(function (n) { return !isNaN(n); });
    if (!keys.length) return null;
    keys.sort(function (a, b) { return Math.abs(a - week) - Math.abs(b - week); });
    return plans[String(keys[0])];
  }

  /* ---- trust badges (honest: only what we can stand behind) ---- */
  function badgesFor(handle) {
    var p = PRODUCTS[handle] || {}, tags = p.tags || [], out = [];
    out.push({ t: 'In date', k: 'trust' });
    out.push({ t: 'Sealed by the brand', k: 'trust' });
    var cert = !isAccessory(p) && (tags.some(function (t) { return t.indexOf('cert:') === 0; }) || p.tested);
    if (cert) out.push({ t: 'Tested for sport', k: 'trust' });
    return out;
  }
  function whyList(r) {
    var w = [], a = state.answers, gl = (CONFIG.goalLabel || {})[r.goal] || 'your goal';
    var hero = PRODUCTS[r.hero] || {};
    w.push('Matched to what you asked for: ' + gl + '.');
    var mg = Number(hero.caffeine);
    if (r.goal.indexOf('downsell') !== 0) {
      if (mg > 0) w.push('About ' + mg + 'mg of caffeine a serve, inside the ceiling you gave us.');
      else if (a.caffeine === 'avoid' || a.time === 'evening') w.push('Zero caffeine. All the pump, none of the wide-awake-at-2am.');
    }
    if (a.time === 'evening' && r.goal.indexOf('downsell') !== 0) w.push('You train close to bed, so we kept the stims out. Sleep beats a buzz.');
    if (a.experience === 'first') w.push('Start with half a scoop for the first week. Go to a full serve once you know how it hits.');
    if (a.tingles === 'hate') w.push('Kept the beta-alanine low, so no face tingles.');
    if (a.tingles === 'love' && r.goal === 'endurance') w.push('Full beta-alanine dose. You know the itch. That is it working.');
    if (a.sideeffects === 'jitters' && mg > 0) w.push((hero.theanine ? 'Theanine in the mix and ' : '') + 'a step down in caffeine, to take the edge off.');
    if (a.sideeffects === 'crash' && a._crashhigh === 'yes') w.push('Dual-source caffeine, so it tapers off instead of dropping you.');
    if (mg >= 400) w.push('This is the strongest thing we stock at ' + mg + 'mg. One scoop. It is not a two-scoop product.');
    return w;
  }

  /* ---- results ---- */
  function renderResults() {
    backBtn.hidden = false;
    CARDS = [];
    var r = score();
    stage.textContent = '';

    if (!r || !r.hero) {
      var msg = document.createElement('div');
      msg.className = 'nzsq-result';
      msg.innerHTML = '<h2 class="nzsq-q__title">We are still stocking your exact match.</h2>' +
        '<p class="nzsq-lede">Your pick is not live yet. Browse the full range in the meantime, or talk to us and we will sort you out.</p>' +
        '<div class="nzsq-result__cta"><a class="nzsq-btn nzsq-btn--primary" href="/collections/all">Shop all products</a>' +
        '<a class="nzsq-btn nzsq-btn--ghost" href="/pages/contact">Talk to a human</a></div>';
      stage.appendChild(msg);
      return;
    }

    var hero = PRODUCTS[r.hero], support = r.support ? PRODUCTS[r.support] : null, addon = r.addon ? PRODUCTS[r.addon] : null;
    var isDownsell = r.goal.indexOf('downsell') === 0;
    var copy = CONFIG.copy || {}, headline = (CONFIG.goalHeadline || {})[r.goal] || 'your goal';
    var root = document.createElement('div'); root.className = 'nzsq-result';

    var head = document.createElement('div'); head.className = 'nzsq-result__head';
    var bl = badgesFor(r.hero).map(function (b) { return '<span class="nzsq-badge nzsq-badge--' + b.k + '">' + esc(b.t) + '</span>'; }).join('');
    var echo = echoLine();
    head.innerHTML = '<p class="nzsq-result__eyebrow">' + esc((CONFIG.eyebrow || {})[r.goal] || 'Your match') + '</p>' +
      (echo ? '<p class="nzpwq-echo">' + esc(echo) + '</p>' : '') +
      '<h2 class="nzsq-result__title">Built for ' + esc(headline) + '.</h2>' +
      '<div class="nzsq-badges">' + bl + '</div>';
    root.appendChild(head);
    if (r.goal === 'energy' && state.answers._cap === 'c0' && !forcedSeg && CONFIG.energyC0Lede) {
      var honest = document.createElement('p'); honest.className = 'nzsq-lede nzpwq-honest';
      honest.textContent = CONFIG.energyC0Lede;
      root.appendChild(honest);
    }
    var lede = (forcedSeg && (CONFIG.offRampLede || {})[r.goal]) || (CONFIG.segmentLede || {})[r.goal];
    if (lede) {
      var ledeEl = document.createElement('p'); ledeEl.className = 'nzsq-lede';
      ledeEl.textContent = lede;
      root.appendChild(ledeEl);
    }

    var stackEl = document.createElement('div'); stackEl.className = 'nzsq-stack';
    function cardTag(h, fallback) { return (copy[h] && copy[h].tag) || fallback; }
    stackEl.appendChild(card(hero, r.hero, cardTag(r.hero, 'Your match'), copy));
    if (support) stackEl.appendChild(card(support, r.support, cardTag(r.support, 'Stack this with it'), copy));
    if (addon) stackEl.appendChild(card(addon, r.addon, cardTag(r.addon, 'Worth adding'), copy));
    root.appendChild(stackEl);

    var why = document.createElement('ul'); why.className = 'nzsq-why';
    whyList(r).forEach(function (t) { var li = document.createElement('li'); li.textContent = t; why.appendChild(li); });
    root.appendChild(why);

    root.appendChild(buyBlock(r));

    var re = document.createElement('p'); re.className = 'nzsq-reassure';
    re.textContent = CONFIG.reassurance || '';
    root.appendChild(re);

    /* NZS-QUIZFIX: universal off-ramp (or back-to-match when a downsell was forced) */
    if (!isDownsell) {
      var strong = (r.goal === 'energy' && state.answers._cap === 'c0');
      var off = document.createElement('button');
      off.type = 'button';
      off.className = 'nzpwq-offramp' + (strong ? ' nzpwq-offramp--strong' : '');
      off.textContent = strong ? 'Not for you? See what we\'d pick instead' : 'Not sold? See what we\'d pick instead.';
      off.addEventListener('click', function () {
        forcedSeg = (state.answers.drinks === 'yes' ? 'downsell-rtd' : 'downsell-protein');
        renderResults();
        stage.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
      });
      root.appendChild(off);
    } else if (isDownsell && forcedSeg) {
      var backLink = document.createElement('button');
      backLink.type = 'button'; backLink.className = 'nzpwq-offramp-back';
      backLink.innerHTML = '<span aria-hidden="true">&larr;</span> Back to my match';
      backLink.addEventListener('click', function () {
        forcedSeg = null;
        renderResults();
        stage.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
      });
      root.appendChild(backLink);
    }

    stage.appendChild(root);
    applyMode('onetime');

    /* NZS-QUIZFIX: result reveal stagger (head 0ms, stack cards 90ms, why-list 180ms) */
    if (canAnimate()) {
      var rvHead = root.querySelector('.nzsq-result__head');
      var rvCards = Array.prototype.slice.call(root.querySelectorAll('.nzsq-stack .nzsq-card'));
      var rvWhy = root.querySelector('.nzsq-why');
      [rvHead].concat(rvCards).concat([rvWhy]).forEach(function (n) { if (n) { n.classList.add('nzpwq-reveal'); n.style.willChange = 'transform, opacity'; } });
      requestAnimationFrame(function () {
        fireReveal(rvHead, 0);
        rvCards.forEach(function (c) { fireReveal(c, 90); });
        fireReveal(rvWhy, 180);
      });
    }
  }

  function card(p, handle, tag, copy) {
    var node = TPL.card.content.cloneNode(true);
    var art = node.querySelector('.nzsq-card');
    node.querySelector('[data-tag]').textContent = tag;
    var ml = node.querySelector('[data-link]'); if (ml) ml.href = p.url || '#';
    var nl = node.querySelector('[data-name-link]'); if (nl) nl.href = p.url || '#';
    node.querySelector('[data-benefit]').textContent = (copy[handle] && copy[handle].benefit) || '';
    var testedEl = node.querySelector('[data-tested]'); if (testedEl && p.tested && !isAccessory(p)) testedEl.hidden = false;
    var cb = node.querySelector('[data-select]'); if (cb) cb.setAttribute('data-handle', handle);

    var flavours = Array.isArray(p.flavours) ? p.flavours : [];
    var st = { handle: handle, art: art, base: p, flavours: flavours, sel: null, entry: null, week: 6, weekTouched: false };
    var idx = CARDS.push(st) - 1; art.setAttribute('data-idx', idx);

    var initEntry;
    if (flavours.length) {
      var def = defaultEntry(flavours, p.id);
      st.sel = { flavour: (def.flavour || ''), size: (def.size || '') };
      buildSelects(st);
      node.querySelector('[data-name]').textContent = familyName(def.title || p.title);
      initEntry = def;
    } else {
      node.querySelector('[data-name]').textContent = p.title;
      initEntry = { vid: p.id, price: p.priceCents, priceMoney: p.price, compareAt: p.compareAt, servings: p.servings, plans: p.plans || {}, image: p.image, available: p.available };
    }
    applyEntry(st, initEntry);
    var _fr = art.querySelector('[data-card-freqrange]'), _fv = art.querySelector('[data-card-freqval]');
    if (_fr) _fr.addEventListener('input', function () { st.week = parseInt(_fr.value, 10) || 6; st.weekTouched = true; if (_fv) _fv.textContent = st.week + ' weeks'; });
    return node;
  }

  function buildSelects(st) {
    var art = st.art, flavours = st.flavours, sel = st.sel;
    var optsWrap = art.querySelector('[data-opts]');
    var fWrap = art.querySelector('[data-flavour-wrap]'), sWrap = art.querySelector('[data-size-wrap]');
    var fSel = art.querySelector('[data-flavour]'), sSel = art.querySelector('[data-size]');
    if (!fSel || !sSel) return;
    var colourOpt = isAccessory(st.base);
    var fLab = art.querySelector('[data-flavour-wrap] .nzsq-card__opt-lab');
    if (fLab) fLab.textContent = colourOpt ? 'Colour' : 'Flavour';
    fSel.setAttribute('aria-label', colourOpt ? 'Colour' : 'Flavour');
    var flavs = flavoursForSize(flavours, sel.size);
    var sizes = distinctSizes(flavours);
    fSel.innerHTML = flavs.map(function (fl) {
      var ent = pickEntry(flavours, fl, sel.size);
      var dis = ent && ent.available === false ? ' disabled' : '';
      return '<option value="' + esc(fl) + '"' + (fl === sel.flavour ? ' selected' : '') + dis + '>' + esc(flavLabel(fl)) + '</option>';
    }).join('');
    sSel.innerHTML = sizes.map(function (sz) {
      return '<option value="' + esc(sz) + '"' + (sz === sel.size ? ' selected' : '') + '>' + esc(sizeLabel(sz)) + '</option>';
    }).join('');
    var showF = flavs.length > 1, showS = sizes.length > 1;
    fWrap.hidden = !showF; sWrap.hidden = !showS;
    optsWrap.hidden = !(showF || showS);
  }

  function applyEntry(st, entry) {
    st.entry = entry;
    var art = st.art;
    var img = art.querySelector('[data-img]');
    if (img && entry.image) { img.src = entry.image; img.alt = familyName(entry.title || st.base.title); }
    var cents = entry.price != null ? entry.price : st.base.priceCents;
    var pm = entry.priceMoney || fmtCents(cents);
    art.setAttribute('data-cents', cents != null ? cents : '');
    art.setAttribute('data-oprice', pm);
    art.setAttribute('data-ocompare', entry.compareAt || '');
    var hasPlans = entry.plans && Object.keys(entry.plans).length > 0;
    art.setAttribute('data-sub', hasPlans ? '1' : '0');
    if (!st.weekTouched) { var _srv = entry.servings || 0; st.week = _srv > 0 ? Math.min(16, Math.max(4, Math.round(_srv / 7))) : 6; }
    var _cfr = art.querySelector('[data-card-freqrange]'), _cfv = art.querySelector('[data-card-freqval]');
    if (_cfr) _cfr.value = st.week; if (_cfv) _cfv.textContent = st.week + ' weeks';
    art.setAttribute('data-vid', entry.vid != null ? entry.vid : '');
    var serveEl = art.querySelector('[data-serve]');
    if (serveEl) {
      var line = serveLine(cents, entry.servings);
      if (line) { serveEl.innerHTML = line; serveEl.hidden = false; } else { serveEl.hidden = true; }
    }
  }

  /* selector change (flavour / size) -> swap variant, image, price, per-serve */
  stage.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || (!t.hasAttribute('data-flavour') && !t.hasAttribute('data-size'))) return;
    var art = t.closest('.nzsq-card'); if (!art) return;
    var st = CARDS[+art.getAttribute('data-idx')]; if (!st || !st.flavours.length) return;
    if (t.hasAttribute('data-size')) {
      st.sel.size = t.value;
      var flavs = flavoursForSize(st.flavours, st.sel.size);
      if (flavs.indexOf(st.sel.flavour) === -1) st.sel.flavour = flavs[0] || '';
    } else {
      st.sel.flavour = t.value;
      var sizes = sizesForFlavour(st.flavours, st.sel.flavour);
      if (sizes.indexOf(st.sel.size) === -1) st.sel.size = sizes[0] || '';
    }
    buildSelects(st);
    applyEntry(st, pickEntry(st.flavours, st.sel.flavour, st.sel.size));
    applyMode(currentMode);
  });

  /* ---- subscribe pricing + per-item note (NZS) ---- */
  var SUB_PCT = 10; /* conservative strike; stack-category products actually subscribe at 15% */
  function subPrice(cents) { return '$' + (Math.round(cents * (100 - SUB_PCT) / 100) / 100).toFixed(2); }
  function applyMode(mode) {
    currentMode = mode;
    stage.querySelectorAll('.nzsq-card').forEach(function (art) {
      var priceEl = art.querySelector('[data-price]'), noteEl = art.querySelector('[data-subnote]');
      if (!priceEl) return;
      var elig = art.getAttribute('data-sub') === '1', cents = parseInt(art.getAttribute('data-cents'), 10);
      var oprice = art.getAttribute('data-oprice') || '', ocomp = art.getAttribute('data-ocompare') || '';
      var plain = ocomp ? '<s>' + esc(ocomp) + '</s> ' + esc(oprice) : esc(oprice);
      if (mode === 'subscribe' && elig && cents) {
        priceEl.innerHTML = '<s>' + esc(oprice) + '</s> <b class="nzsq-card__subprice">' + esc(subPrice(cents)) + '</b>';
        if (noteEl) { noteEl.hidden = true; noteEl.removeAttribute('data-kind'); }
      } else if (mode === 'subscribe' && !elig) {
        priceEl.innerHTML = plain;
        if (noteEl) { noteEl.textContent = 'One-time only; not included in the subscription'; noteEl.hidden = false; noteEl.setAttribute('data-kind', 'once'); }
      } else {
        priceEl.innerHTML = plain;
        if (noteEl) { noteEl.hidden = true; noteEl.removeAttribute('data-kind'); }
      }
      var _cf = art.querySelector('[data-card-freq]');
      if (_cf) _cf.hidden = !(mode === 'subscribe' && art.getAttribute('data-sub') === '1');
    });
  }

  /* ---- buy block ---- */
  function selectedItems() {
    var items = [];
    CARDS.forEach(function (st) {
      var cb = st.art.querySelector('[data-select]');
      if (!cb || !cb.checked) return;
      var e = st.entry; if (!e || e.vid == null) return;
      var item = { id: e.vid, quantity: 1 };
      if (currentMode === 'subscribe' && e.plans && Object.keys(e.plans).length) {
        var pid = e.plans[String(st.week)] || nearestPlan(e.plans, st.week);
        if (pid) item.selling_plan = pid;
      }
      items.push(item);
    });
    return items;
  }
  function buyBlock(r) {
    var box = document.createElement('div'); box.className = 'nzsq-buy';
    var anyPlan = CARDS.some(function (st) { return st.entry && st.entry.plans && Object.keys(st.entry.plans).length > 0; });
    currentMode = 'onetime';
    var toggle = document.createElement('div'); toggle.className = 'nzsq-toggle';
    toggle.appendChild(toggleOpt('onetime', 'One-time', CONFIG.onetimeNote || 'Pay once', currentMode, true));
    toggle.appendChild(toggleOpt('subscribe', CONFIG.subscribeLabel || 'Subscribe & save', anyPlan ? (CONFIG.subscribeNote || 'Subscribe & save, cancel anytime') : (CONFIG.subscribeSoon || 'Subscribe & save when it launches'), currentMode, anyPlan));
    toggle.addEventListener('click', function (e) {
      var opt = e.target.closest('.nzsq-toggle__opt'); if (!opt || opt.getAttribute('data-disabled')) return;
      var mode = opt.getAttribute('data-mode');
      toggle.querySelectorAll('.nzsq-toggle__opt').forEach(function (o) { o.setAttribute('data-active', o.getAttribute('data-mode') === mode); });
      applyMode(mode);
    });
    box.appendChild(toggle);

    /* per-product delivery cadence sliders now live inside each card (data-card-freq) */

    var ctas = document.createElement('div'); ctas.className = 'nzsq-buy__cta';
    var addBtn = btn('primary', 'Add my stack to cart');
    addBtn.addEventListener('click', function () {
      var items = selectedItems();
      if (!items.length) { feedback(box.querySelector('[data-nzsq-feedback]'), 'Tick at least one item to add.', true); return; }
      addToCart(items, addBtn);
    });
    ctas.appendChild(addBtn);
    box.appendChild(ctas);
    var fb = document.createElement('p'); fb.className = 'nzsq-feedback'; fb.setAttribute('data-nzsq-feedback', ''); fb.setAttribute('aria-live', 'polite');
    box.appendChild(fb);
    return box;
  }
  function toggleOpt(modeId, label, note, active, enabled) {
    var el = document.createElement('label'); el.className = 'nzsq-toggle__opt';
    el.setAttribute('data-mode', modeId); el.setAttribute('data-active', modeId === active);
    if (!enabled) el.setAttribute('data-disabled', 'true');
    el.innerHTML = '<input type="radio" name="nzsq-buymode" value="' + modeId + '"' + (enabled ? '' : ' disabled') + '>' +
      '<strong>' + esc(label) + (enabled ? '' : ' <span class="nzsq-soon">Soon</span>') + '</strong><span>' + esc(note) + '</span>';
    return el;
  }
  function buildFreq() {
    var wrap = document.createElement('div'); wrap.className = 'nzsq-freq';
    wrap.innerHTML =
      '<div class="nzsq-freq__top"><span class="nzsq-freq__lab">Deliver every</span><span class="nzsq-freq__val" data-freqval>' + selectedWeek + ' weeks</span></div>' +
      '<input type="range" class="nzsq-freq__range" data-freqrange min="4" max="16" step="1" value="' + selectedWeek + '" aria-label="Weeks between deliveries">' +
      '<p class="nzsq-freq__help">Pick the gap that matches how fast you get through it. Change or cancel anytime.</p>';
    var range = wrap.querySelector('[data-freqrange]'), val = wrap.querySelector('[data-freqval]');
    range.addEventListener('input', function () {
      selectedWeek = parseInt(range.value, 10) || 6;
      val.textContent = selectedWeek + ' weeks';
    });
    return wrap;
  }
  function addToCart(items, triggerBtn) {
    var fb = stage.querySelector('[data-nzsq-feedback]');
    if (!items.length) { feedback(fb, 'Nothing to add right now.', true); return; }
    triggerBtn.disabled = true; feedback(fb, 'Adding to your cart...', false);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { if (!res.ok) throw new Error('cart'); delCookie(COOKIE); window.location.href = '/cart'; })
      .catch(function () { triggerBtn.disabled = false; feedback(fb, 'Something went wrong. Please try again.', true); });
  }
  function feedback(el, msg, isErr) { if (!el) return; el.textContent = msg; el.setAttribute('data-state', isErr ? 'error' : 'ok'); }

  /* ---- helpers ---- */
  function btn(kind, label) { var b = document.createElement('button'); b.type = 'button'; b.className = 'nzsq-btn nzsq-btn--' + kind; b.textContent = label; return b; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* ---- wire up ---- */
  document.querySelectorAll('[data-nzpwq-start]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); open(el.getAttribute('data-nzpwq-goal') || null); });
  });
  if (backBtn) backBtn.addEventListener('click', back);
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !app.hidden) close(); });
})();
